import * as React from 'react';

import { Toast } from '../@types/types';
import { ErrorIcon, ErrorTheme } from './error';
import { LoaderIcon, LoaderTheme } from './loader';
import { CheckmarkIcon, CheckmarkTheme } from './checkmark';

export type IconThemes = Partial<{
  success: CheckmarkTheme;
  error: ErrorTheme;
  loading: LoaderTheme;
}>;

export const ToastIcon: React.FC<{
  toast: Toast;
}> = ({ toast }) => {
  // @ts-ignore
  const { icon, type, iconTheme } = toast;
  if (icon !== undefined) {
    if (typeof icon === 'string') {
      return (
        <div className=" relative scale-50 opacity-40 min-w-[1.25rem]">
          {icon}
        </div>
      );
    } else {
      return icon;
    }
  }

  if (type === 'blank') {
    return null;
  }

  return (
    <div className=" relative flex justify-center items-center min-w-[1.25rem] min-h-[1.25rem]">
      <LoaderIcon />
      {type !== 'loading' && (
        <div className="absolute">
          {type === 'error' ? <ErrorIcon /> : <CheckmarkIcon />}
        </div>
      )}
    </div>
  );
};
